
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-compatibility-helpers/-embroider-implicit-modules.js";
import "ember-copy/-embroider-implicit-modules.js";
